import moment from "moment";
import { toast } from "react-toastify";
import { apiHost } from "./setting";
import queryString from "query-string";
import { useLocation } from 'react-router-dom';

export const SetAuthToken = (token: string): void => {
  localStorage.setItem("tpmauth", token);
};

export const GetAuthToken = (): string => {
  return localStorage.getItem("tpmauth") as string;
};

export const RemoveAuthToken = () => {
  localStorage.removeItem("tpmauth");
};

export const VerifyAuthToken = (): boolean => {
  return (
    localStorage.getItem("tpmauth") !== "" &&
    localStorage.getItem("tpmauth") !== null
  );
};

export const IpDataTypeEnums: MasterEnums[] = [
  { name: "Text", id: "0f8fad5b-d9cb-469f-a165-70811728950e" },
  { name: "Numeric", id: "0f8fad5b-d9cb-469f-a165-70867728950e" },
  { name: "Options", id: "0f8fad5b-d9cb-469f-a165-70867799950e" },
  { name: "Boolean", id: "0f8fad5b-d9cb-469f-a165-11867728950e" },
];

export const ScheduleRouteStatusEnums: MasterEnums[] = [
  { id: "5F9CBBF4-F9AE-4E4A-AA59-0A2F5C4FD26F", name: "In Progress" },
  { id: "4F6614E2-47B6-497A-94EA-1D77B01D811C", name: "Skipped" },
  { id: "FCA7ED1B-1263-4C50-BCD7-56F725DD78FF", name: "Missed" },
  { id: "0F3134BE-DB07-4444-ABB2-878853FC4D48", name: "Completed" },
  { id: "B5855293-7BF1-474A-8636-B2344E8B3995", name: "Pending" },
];

export const IpCriticalityEnums: MasterEnums[] = [
  { name: "Highly Critical", id: "FCA7ED1B-1263-4C50-BCD7-56F725DD78FF" },
  { name: "Medium Critical", id: "FCA7ED1B-1263-4C50-BCD7-56F7266D78FF" },
  { name: "Low Critical", id: "FCA7ED1B-1263-4C50-BCD7-5777266D78FF" },
];

export const EquipmentCriticalityEnums: MasterEnums[] =[
  { id: "07E2B69E-EBA3-44E5-AE0E-6A5040DB3D9D", name: "Highly Critical" },
  { id: "A3ACD78D-9648-45AB-BBD9-B02C18E2C77E", name: "Medium Critical" },
  { id: "888A5266-E717-4956-8A24-D0D9B6FBCDDF", name: "Low Critical" }
]

export const WeekDaysEnums: MasterEnums[] = [
  {
    id: "35afef11-9f4a-412f-b435-84d34cb596a0",
    name: "Sunday",
  },
  {
    id: "84a284d3-4065-402a-9210-0bc7da784476",
    name: "Monday",
  },
  {
    id: "b1e958f1-3bc8-4526-b9d9-7b28b775d700",
    name: "Tuesday",
  },
  {
    id: "fda6c14f-ed58-4370-ad1c-9f927073a195",
    name: "Wednesday",
  },
  {
    id: "4c45b576-bc6f-48b9-81f0-41d0142c624e",
    name: "Thursday",
  },
  {
    id: "486dd308-30e9-4c12-ae94-25243e890254",
    name: "Friday",
  },
  {
    id: "d61bcdf8-2b5b-437b-92f6-65781492b1c1",
    name: "Saturday",
  }
];

export const makeID = (length) => {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const decryptToken = (): { userID: string; RoleID: string } => {
  const token = GetAuthToken();
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  const backendToken = JSON.parse(JSON.parse(jsonPayload).token);
  return { userID: backendToken.UserId, RoleID: backendToken.RoleId };
};


export const convertDateTimeToUtcDate = (date: any): string =>
  moment(date).utc().format("YYYY-MM-DD");

export const initPaginateListPayloadGlobal: PaginatedListPayload = {
  page: 0,
  pageSize: 10000000,
  totalRecords: 0,
  search: "",
  sortBy: [{ name: "Name", direction: "asc" }],
};

export function initPaginateListResponseGlobal<T>(
  initData: T
): PaginatedListResponse<T> {
  return {
    page: 0,
    pageSize: 1000,
    totalRecords: 0,
    search: "",
    sortBy: [{ name: "Name", direction: "asc" }],
    data: initData,
  };
}

export function showErrorNotification(message: string) {
  toast.error(message, {
    position: "bottom-left",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export function showSuccessNotification() {
  toast.success("Operation completed successfully", {
    position: "bottom-left",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export function getImageHost() {
  return apiHost;
}

export enum EnumAppRights {
  ImportInspectionpointsManagement = "58BB1744-B619-4BA1-AC38-127EEE99B9E3",
  AlarmedEquipmentsManagement = "8F501E1D-49CC-466E-9E5E-15E1339ED6EE",
  SectionsManagement = "143376B9-DD20-4A02-8860-2345A627E975",
  IpTypeAnomalyReport = "E43F42FD-C540-4304-89C0-38D63AEBB66F",
  InspectionPointManagement = "817D6F5A-22E9-49BF-9F1F-460AA2BFE1DA",
  RoutesManagement = "63D7AA6A-4834-48E1-8C51-480D6E09FC94",
  FixRequestsManagement = "A8A060AF-F6D2-4BB8-88E6-4D29220115E8",
  ScheduledRoutesManagement = "E79BAD41-67AF-466F-8930-5A0B81215E8B",
  EquipmentManagement = "931E85CE-8691-4E23-9D07-5E458E438895",
  CreateUpdateRouteManagement = "3A64BD7F-204A-4162-AAB3-6EFD0875D90E",
  BranchManagement = "2244AE96-7F11-4E6A-8042-7C46CB45ADA5",
  DailyReport = "5A7E4EF7-DD10-4F05-98D6-9A1F83FDBB99",
  UsersManagement = "8AD500D6-9D98-41CB-A216-9DEA9EB4DCC6",
  EquipmentBI = "73205599-362E-4B83-AE61-9F0EF10DBA7F",
  SubSectionsManagement = "B0473AD3-505C-473A-A4A9-B26AD26217C2",
  ImportAssets = "9D5D332D-00C9-4E56-B47C-B8A6193ED9BA",
  ImportEquipments = "AFB79426-A5E2-460F-8B01-CFED3710A21B",
  LastInspectionIpStatusReport = "7A4A76C9-1FEF-484A-9B7C-E5396C0595C0",
  Dashboard = "D5A4C11C-A704-41A4-8C55-EC4F090E0FA3",
  RolesRightsManagement = "DD003CD0-55FC-424F-9726-F632E36AB645",
  EquipmentHealthReport = "3A598F3C-95FD-4550-9E8C-F6D491349806",
  AssetManagement = "0390AAC1-5950-4668-9B0A-E40B3DC9542D",
  ExploreBI = "880D46D2-6C8A-4FEA-B044-E9ACFC7C6FCD",
  Notification = "0FCABD11-ED60-4661-B479-61228DA6D1FE",
  ShiftsManagment = "B210669A-5808-4F3F-8212-0857114530AF",
  UserBI = "73EDA04C-56B6-4255-B456-4AE9051E04D4",
  TeamsManagement = "E144FE8B-2160-45EB-A8BE-8765E98E6358",
  EDocsManagement = "1612E013-690F-4305-86BA-604814A94A46",
  TemplateManagement = "9F369896-38B3-4705-8E2C-15285AB9BCE8",
  IpUutilization = "af181c94-4bac-45f8-bbfe-0b02d1dceaad",
  RouteScheduleSummary = "00B0592D-E467-4F70-905E-13E1ADC4DC15"
}

export enum WorkOrderStatusEnum {
  ApprovalWaiting = "BCE112CD-13E1-488C-B48B-2AB0264507BC",
  Resolved = "57178893-6B79-429C-929D-6CE98D8B61F3",
  Pending = "AFD0B038-D9F2-492A-832F-A6DE194CA7FC",
  InProgress = "A1581C5F-4554-4A1F-AEE4-ED6366FEBE4E"
};

export enum UploadMediaFileType {
  Documents = 1,
  Image = 2,
};

export enum RouteFrequencyEnum {
  Hours = "F20C17F4-6C01-457E-81FB-95ECF8F74EB4",
  Monthly = "1E655FCD-1B94-4967-9943-CD8B31A59272",
  Yearly = "720C0D69-B45D-47C8-8CC9-7EF433392030",
  Days = "FB7303EB-524E-4EDE-8207-2213545F272B"
}

export enum WorkOrderSourcEnum {
  Observation = "224BCA78-01B5-4374-866E-7BAADEDB7063",
  Route = "EF6F3522-F291-4968-B872-A5062ECEF4DD"
};

export const cbmLogoSvg64: string = 'data:image/svg+xml;base64,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';

export const compressImage = (e, handleChange, data, isUser) => {
  const width = 35;
  const height = 35;
  const fileName = e.target.files[0].name;
  let exportFileName;
  const reader = new FileReader();
  reader.readAsDataURL(e.target.files[0]);
  reader.onload = event => {
    const img = new Image();
    img.src = event.target?.result;
    img.onload = () => {
      const elem = document.createElement('canvas');
      elem.width = width;
      elem.height = height;
      const ctx = elem.getContext('2d');
      ctx?.drawImage(img, 0, 0, width, height);
      ctx?.canvas.toBlob((blob) => {
        const file = new File([blob], fileName, {
          type: 'image/jpeg',
          lastModified: Date.now()
        });
        exportFileName = file;
        if (isUser) {
          handleChange({ ...data, profileImage: file });
        }
        else {
          handleChange({ ...data, LogoPath: file });
        }
      }, 'image/jpeg', 1);
    },
      reader.onerror = error => console.log(error);
  };
}

export const getQueryString = (paramName: string): string | null => {
  const location = useLocation();
  const queryParams: any = queryString.parse(location.search);
  return queryParams[paramName] || null;
};

export enum UploadMediaTypes {
  Document = "BFE46F9C-5DBC-4E69-BF3A-09F8B5DD4154",
  Video = "E3D2DD2E-6872-4C64-AF16-4F13015D09CA",
  Image = "DB91C671-EA63-411B-9586-FB42B61A4078",
  Audio = "5E7FB846-867D-40E3-81F4-FE2F160001CB"
}

export enum RouteStatusIds {
  Active = "FCA7ED1B-1263-4C50-BCD7-56F725DD78FF",
  Inactive = "D1A3629C-E3AF-404A-B6A9-723386EDC419",
}

export const isGUID =(input)=> {
  const guidRegex = /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/;
  return guidRegex.test(input);
}

export enum TemplateTypeEnum {
  Branch = "938A3A72-72B6-40E7-B247-383F6C2B5823",
  Section = "F0E3F28D-5268-4FE3-9B7E-488EA4DAB0B5",
  SubSection = "77F6FFE8-5FC9-4BB0-9DEA-7138216A069B",
  Asset = "B7FECE02-7D12-4CF8-A401-31940C0EC92D",
  Equipment = "0C3462DD-170C-49BA-84E0-0C7072915454",
  IP = "D58F70C8-A309-4C2A-AB11-48FAD89E902E",
  IpOptions = "8789C592-97AC-4DFD-B5D8-CE930AFB96FE",
  IpAnomalyRanges = "DADE4FA3-5364-462B-968B-47599D7DD438"
}

export enum RecipeSidebarState {
  Close,
  Open,
  FullWidth
}

export enum HealthStatusEnum {
  Normal = 80,
  Abnormal = 0,
  NotApplicable = -1,
}

export const getNewGUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export const WorkOrderStatusEnums: MasterEnums[] = [
 {
    id: WorkOrderStatusEnum.ApprovalWaiting,
    name: "Approval Waiting",
  },
 {
    id: WorkOrderStatusEnum.Resolved,
    name: "Resolved",
  },
 {
    id: WorkOrderStatusEnum.Pending,
    name: "Pending",
  },
   {
    id: WorkOrderStatusEnum.InProgress,
    name: "In Progress",
  },
];

// Standard date format for all views
export const STANDARD_DATE_FORMAT = "DD/MM/YYYY";

export function formatDateForView(date: any, format: string = STANDARD_DATE_FORMAT): string {
  const m = moment(date);
  return m.isValid() ? m.format(format) : "";
}